module.exports = __webpack_public_path__ + "static/media/0029_Medium.81950b8f.jpg";